import { Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Switch, TextField } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { AlimentacaoService } from '../../../shared/services/api/fazenda/alimentacao/AlimentacaoService';
import RAli from './RAli';

export const RelatoriosAli: React.FC = () => {

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<Dayjs | null>(dayjs());
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [checked, setChecked] = useState(false);
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;   
    }
    setOpenmsg(false);
  };

  const handleVisualizar = () => {
    setIsLoading(true);
    AlimentacaoService
      .relatorioAli(dayjs(data).format('DD/MM/YYYY'), checked)
      .then((result) => {
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } else {
          RAli(result, dayjs(data).format('DD/MM/YYYY'))
        }
      });
  };

  return (
    <Box alignItems="center" width='auto' alignContent='center' height="auto" display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1} padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' alignContent='center'></Box>
      <Box width='auto' alignItems="center" component={Paper} height="auto" margin={1}
        alignContent='center'>
        <DialogTitle>Relatório de Refeição</DialogTitle>
        <DialogContent dividers>
          {isLoading && (
            <Grid item>
              <LinearProgress variant='indeterminate' />
            </Grid>
          )}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format='DD/MM/YYYY'
              value={data}
              onChange={(newValue) => setData(newValue)}
              slotProps={{
                textField: {
                  size: 'small',
                }
              }}
            />
          </LocalizationProvider>
          <FormControlLabel
            control={
              <Switch     
                checked={checked}
                onChange={e => { setChecked(e.target.checked)}}
                color="primary"
                defaultChecked
              />
            }
            label='Confirmado'
            labelPlacement="start"
          />
        </DialogContent>
        <DialogActions>
          <Button sx={{ minWidth: '30%' }} variant='outlined' autoFocus onClick={handleVisualizar}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};